class FeaturedProducts extends HTMLElement {
  constructor() {
    super();

    this.LOADING = false;
    this.LOADING_CLASS = "featured-products__media--loading";

    this.isMobile = window.matchMedia("(max-width: 749px)").matches;
    this.hotspots = this.querySelectorAll(".js-hotspot");
    this.swatches = this.querySelectorAll(".js-colour-swatch");
    this.variantLink = this.querySelector(".card__link");
    this.tabs = this.querySelectorAll(".js-tab");
    this.close = this.querySelector(".js-popover-close");

    this.addListeners();
    this.placeHotspots();

    if (this.swatches.length) this.initialiseColours();
  }

  initialiseColours() {
    const contents = this.querySelectorAll(".js-content");

    contents.forEach((content, idx) => {
      const swatch = content.querySelector(".js-colour-swatch");

      if (!swatch) return;

      this.setTabColours(swatch);

      if (idx === 1) this.setSectionBackgroundColour(swatch);
    });
  }

  addListeners() {
    this.hotspots.forEach((hotspot) =>
      hotspot.addEventListener("click", () => this.togglePopover(hotspot))
    );
    this.swatches.forEach((swatch) =>
      swatch.addEventListener("click", () => this.setVariant(swatch))
    );

    if (this.isMobile)
      this.close.addEventListener("click", (event) => this.closePopover(event));

    subscribe(PUB_SUB_EVENTS.tabOpen, ({ tab }) =>
      this.changeBackgroundColour(tab)
    );
  }

  placeHotspots() {
    this.hotspots.forEach((hotspot) => {
      const type = this.isMobile ? "locationMobile" : "location";
      const coords = hotspot.dataset[type].split(",");

      hotspot.style = `left: ${coords[0]}%; top: ${coords[1]}%;`;
    });
  }

  togglePopover(hotspot) {
    this.hotspots.forEach((allSpots) => {
      if (
        allSpots != hotspot &&
        allSpots.classList.contains("featured-products__hotspot--active")
      ) {
        allSpots.classList.toggle("featured-products__hotspot--active");
      }
    });

    if (this.isMobile) document.body.classList.toggle("shadow--body");

    hotspot.classList.toggle("featured-products__hotspot--active");
  }

  setVariant(swatch) {
    this.changeImage(swatch).then(() => {
      this.setTabColours(swatch);
      this.setSectionBackgroundColour(swatch);
      this.updateSwatches(swatch);
    });
  }

  async changeImage(swatch) {
    const content = swatch.closest(".js-content");
    const product = swatch.dataset.productHandle;
    const variant = swatch.dataset.variantId;
    const media = content.querySelector(".js-media");
    const section = await this.getVariant(product, variant, media);

    if (section) {
      const newMedia = section.querySelector(".js-media");

      if (media && newMedia) media.innerHTML = newMedia.innerHTML;

      this.removeLoadingStatus(media);
    }
  }

  getVariant(product, variant, media) {
    const url =
      window.routes.root_url +
      "products/" +
      product +
      "?variant=" +
      variant +
      "&section_id=featured-products-content";

    if (this.LOADING) return;

    media.classList.add(this.LOADING_CLASS);

    this.LOADING = true;

    return fetch(url)
      .then((response) => response.text())
      .then((response) =>
        new DOMParser().parseFromString(response, "text/html")
      )
      .catch((error) => {
        console.error(error);

        this.removeLoadingStatus(media);
      });
  }

  changeBackgroundColour(tab) {
    const contents = Array.from(this.querySelectorAll(".js-tab-content"));
    const content = contents.find(
      ({ dataset }) => dataset.content === tab.dataset.tab
    );
    const swatches = content.querySelectorAll(".js-colour-swatch");
    const swatch = [...swatches].find((swatch) =>
      swatch.classList.contains("active")
    );

    if (swatch) this.setSectionBackgroundColour(swatch);
  }

  setTabColours(swatch) {
    const colour = swatch.dataset.colour;
    const content = swatch.closest(".js-tab-content").dataset.content;
    const tab = Array.from(this.tabs).find(
      (tab) => tab.dataset.tab === content
    );
    if (tab) {
      const tab_icon = tab.querySelector(".icon");
      tab.style.setProperty("--underline-colour", colour);
      if (tab_icon) {
        tab_icon.style.color = colour;
      }
    }
  }

  setSectionBackgroundColour(swatch) {
    this.style.backgroundColor = `${swatch.dataset.colour}33`; // 33 = Add 20% Opacity
  }

  updateSwatches(activeSwatch) {
    this.swatches.forEach((swatch) => {
      const handle = swatch.dataset.productHandle;
      const variant = activeSwatch.dataset.variantId;
      const activeHandle = activeSwatch.dataset.productHandle;

      if (handle === activeHandle) swatch.classList.remove("active");
      if (variant && handle)
        this.variantLink.href = `/products/${handle}?variant=${variant}`;
    });

    activeSwatch.classList.add("active");
  }

  closePopover(event) {
    event.stopPropagation();

    const hotspot = event.target.closest(".featured-products__hotspot");

    this.togglePopover(hotspot);
  }

  removeLoadingStatus(media) {
    media.classList.remove(this.LOADING_CLASS);

    this.LOADING = false;
  }
}

customElements.define("featured-products", FeaturedProducts);
